import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Executes record unassignment through the record-owned plugin API.
 */
export const executeUnassign = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.unassign.request.observe().pipe(
      rxjs.mergeMap(action =>
        plugin.api.unassign(action.data).pipe(
          rxjs.map(() =>
            feature.actions.unassign.success.from(action).create({
              request: action.data,
            }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.unassign.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        ),
      ),
    ),
)
